module.exports = [
  require('./dalelands'),
  require('./damara'),
  require('./dambrath'),
  require('./dragon_coast'),
  require('./durpar'),
]
